import React from 'react';
import { useLaunchParams } from '@telegram-apps/sdk-react';
import '../scss/Courses.scss'; // Подключаем стили
import api from "../../api";
import { useCurrency } from "../../contexts/CurrencyContext";

const CorsesCard = () => {
  const { isLoaded, usd, cny, courseDate } = useCurrency();
  const formattedDate = new Date(courseDate).toLocaleDateString('ru-RU');
  return (
    <div className='course-container'>
      <div className='title-container'>
        <div className='title'>Курс валют</div>
        <div className='right-sub-title'>Актуально {formattedDate}</div>
      </div>
      <div className='course-card'>
        <div className='currency'>
          <div className='currency-image-container'>
            <div className='currency-image'>
              <img src="/images/cny.png" alt="" />
            </div>
            <div className='currency-text'>
              <div className='currency-title'>
                Китайский юань
              </div>
              <div className='currency-code'>
                CNY
              </div>
            </div>
          </div>
          <div className='currency-amount'>
            {cny.toLocaleString("ru-RU")} ₽
          </div>
        </div>
        <div className='line'></div>
        <div className='currency'>
          <div className='currency-image-container'>
            <div className='currency-image'>
              <img src="/images/usd.png" alt="" />
            </div>
            <div className='currency-text'>
              <div className='currency-title'>
                Доллар
              </div>
              <div className='currency-code'>
                USD
              </div>
            </div>
          </div>
          <div className='currency-amount'>
            {usd.toLocaleString("ru-RU")} ₽
          </div>
        </div>
      </div>
      
    </div>
  )
}

export default CorsesCard;
